import { RootState } from '../store';

const selectAddress = (state: RootState) => state.address.selectedAddress;
const selectIsAddressClicked = (state: RootState) => state.address.isAddressClicked;

export const AddressSelector = {
  selectAddress,
  selectIsAddressClicked,
};